import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { IconButton, Button, Dialog, DialogActions, DialogContent, DialogTitle, Slide, InputLabel, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SimpleReactValidator from 'simple-react-validator';
import LaddaButton, { EXPAND_RIGHT } from 'react-ladda';
import { itemService, globalService as gs } from '../../../common/services';
import { alertSelectors } from '../../../common/redux/selectors';
import { orderStatus } from '../../../helpers';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class CancelBookingDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            UserCatalogOrders: {
                status: orderStatus.ORDER_CANCELLED,
                comment: '',
            },
            loading: false,
        };
        this.resetForm = this.state;
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            className: 'invalid-feedback d-block',
        });
    }
 
    handleClose = (e, item = false) => this.props.onClose(item);

    handleChange = (e) => {
        let UserCatalogOrders = {...this.state.UserCatalogOrders};
        UserCatalogOrders[e.target.name] = e.target.value;
        this.setState({UserCatalogOrders});
    };
    
    handleSubmit = (e) => {
        e.preventDefault();
        if( this.validator.allValid() ){
            const { UserCatalogOrders } = this.state;
            const { dispatch, item } = this.props;
            this.setState({loading: true});
            console.log(UserCatalogOrders);

            itemService.booking("POST", {UserCatalogOrders}, { order_id: item.id, key: 'cancel' }).then(data => {
                if(data.code) {
                    console.log('data.model', data)
                    this.props.onClose(data.model);
                    dispatch(alertSelectors.success("You have successfully cancel booking"));
                    this.setState({UserCatalogOrders: {
                        comment: '',
                    }});
                } else {
                    dispatch(alertSelectors.error("Action not accept"));
                }
                this.setState({loading: false});
            })
            .catch(exception => {
                gs.showErrors(dispatch, exception, alertSelectors);
                this.setState({loading: false});
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    render() {
        this.validator.purgeFields();
        const { UserCatalogOrders } = this.state;
        const { open } = this.props;
        //console.log('this.props', this.props);
        return (
            <div>
                <Dialog
                    open={open}
                    onClose={this.handleClose}
                    scroll={"paper"}
                    TransitionComponent={Transition}
                    keepMounted
                    className="custom-dialog review"
                >
                    <DialogTitle className="heading text-left cancel-booking" disableTypography style={{padding: "10px 25px"}}>
                        <Typography variant="h6">Cancel Booking</Typography>
                        <IconButton aria-label="close" className="closeButton" onClick={this.handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <form name="cancel_booking" onSubmit={this.handleSubmit} encType="multipart/form-data" noValidate>
                        <DialogContent>
                            <div className="form-group">
                                <InputLabel className="text-info">Reason</InputLabel>
                                <textarea 
                                className="form-control"
                                value={UserCatalogOrders.comment} 
                                name="comment"
                                onChange={this.handleChange} />
                                {this.validator.message('comment', UserCatalogOrders.comment, 'required')}
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <LaddaButton className="btn btn-primary" loading={this.state.loading} data-style={EXPAND_RIGHT}>Submit</LaddaButton>
                            <Button color="primary" onClick={this.handleClose} className="btn btn-secondary">
                                Cancel
                            </Button>
                        </DialogActions>
                    </form>
                </Dialog>
            </div>
        );
    }
}


const processSelector = createSelector(
    state => state.process,
    process => process
);

const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const mapStateToProps = createSelector(
    processSelector,
    authenticationSelector,
    (process, authentication) => ({
        process, authentication
    })
);

export default connect(mapStateToProps)(CancelBookingDialog);